import { render, staticRenderFns } from "./PointDetail.vue?vue&type=template&id=2fd5768e"
import script from "./PointDetail.vue?vue&type=script&lang=js"
export * from "./PointDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports